import React from "react";
import ClientsList from "../components/Clients/ClientsList";
import PageHero from "../components/PageHero";

function ClientsPage() {
  return (
    <>
      <PageHero
        title="Our Esteemed Clients"
        crumb="Clients"
        subtitle="Trusted by leading organizations across India for quality construction services"
      />
      <section className="bg-gray-50 py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <ClientsList />
        </div>
      </section>
    </>
  );
}

export default ClientsPage;
